import React from 'react'
import { ChevronDown } from 'lucide-react'

// A header filter: a button that opens a checklist. Only what the response's
// filter_options offers is ever an option, so a name here always comes from
// the backend. Changes apply the moment a box is ticked.
export default function FilterMenu({ label, options, selected, onChange }) {
  const active = selected.length > 0
  const summary = !active
    ? `All ${label.toLowerCase()}s`
    : selected.length === 1
      ? options.find((o) => o.value === selected[0])?.label || `1 ${label.toLowerCase()}`
      : `${selected.length} ${label.toLowerCase()}s`

  const toggle = (value) => onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value])

  return (
    <details className="bk-filter" data-active={active ? 'true' : undefined}>
      <summary aria-label={`${label} filter: ${summary}`}>
        <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}>{label}:</span> {summary}
        <ChevronDown size={13} aria-hidden="true" />
      </summary>
      <div className="bk-filter-menu" role="group" aria-label={label}>
        {options.length === 0 ? (
          <span style={{ padding: '6px 8px', fontSize: 12, color: 'var(--text-muted)' }}>None in this range</span>
        ) : options.map((o) => (
          <label key={o.value}>
            <input type="checkbox" checked={selected.includes(o.value)} onChange={() => toggle(o.value)} />
            {o.label}
          </label>
        ))}
        {active && (
          <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: 4 }} onClick={() => onChange([])}>
            Clear
          </button>
        )}
      </div>
    </details>
  )
}
